<template>
  <div class="customers pb-9">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card class="dialog-card pa-0">
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text class="pt-3">
          <v-btn
            elevation="3"
            height="45"
            color="grey darken-1"
            class="me-3"
            outlined
            small
            style="border-radius: 6px !important; font-size: 17px !important"
            >n</v-btn
          >
          <b>افزودن مشتری جدید</b>
        </v-card-text>
        <v-card-subtitle>
          <v-btn
            elevation="3"
            height="45"
            color="grey darken-1"
            class="me-3"
            outlined
            small
            style="border-radius: 6px !important; font-size: 17px !important"
            >q</v-btn
          >
          <b>بستن این راهنما</b>
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-card class="common-card">
      <div class="d-flex flex-column flex-md-row">
        <h4 class="c-grey pt-2">مشتریان</h4>
        <v-divider class="me-10 ms-10 d-none d-md-block" vertical></v-divider>
        <div class="custom-input2 mt-3 mt-md-0">
          <v-text-field
            hide-details
            outlined
            dense
            label="جستجو در نام مشتریان..."
            prepend-icon="$Search"
            @input="currentPage = 1"
            v-model="filter"
          >
            <template v-slot:append>
              <v-icon
                v-if="filter.length"
                class="red--text text--lighten-2"
                @click="
                  filter = '';
                  currentPage = 1;
                "
                >mdi-close-circle</v-icon
              >
            </template>
          </v-text-field>
        </div>
      </div>
      <hr class="mt-5" />
      <v-card v-if="loading" flat>
        <div class="d-flex flex-column align-items-center mt-8 py-6">
          <atom-spinner
            :animation-duration="1000"
            :size="80"
            :color="'#7c4dff'"
          />
          <p class="primary--text font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
      </v-card>
      <v-card v-else flat>
        <v-container class="pt-12">
          <v-row>
            <v-col class="d-flex flex-row">
              <h4 class="primary--text">مشتریان فروشگاه</h4>
              <span style="padding-top: 2px" class="c-grey ms-4"
                >({{ customers.length }} مشتری)</span
              >
            </v-col>
            <v-col class="text-left">
              <!--              <v-btn-->
              <!--                @click="openNewProduct()"-->
              <!--                @shortkey="openNewProduct()"-->
              <!--                v-shortkey.once="['n']"-->
              <!--                class="orange-borderedBtn"-->
              <!--                height="43"-->
              <!--              >-->
              <!--                <v-icon class="me-1">$Bag</v-icon>افزودن مشتری جدید-->
              <!--              </v-btn>-->
            </v-col>
            <v-col>
              <div class="text-left">
                <vue-excel-xlsx
                  v-if="customers.length"
                  :data="customers"
                  style="width: 180px; height: 43px"
                  class="darkGreen-mainBtn white--text py-2 mb-6"
                  :columns="excelFields"
                  :filename="'مشتریان'"
                  sheetname="مشتریان"
                >
                  <v-icon class="white--text">mdi-file-excel</v-icon> دریافت
                  اکسل
                </vue-excel-xlsx>
              </div>
            </v-col>
          </v-row>
          <hr />
          <div class="custom-table mt-3">
            <b-table
              responsive
              show-empty
              :current-page="currentPage"
              :per-page="perPage"
              :items="computedItems"
              :fields="customersFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد."
              striped
              thead-class="headClass"
              tbody-class="bodyClass"
            >
              <template v-slot:empty>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  رکوردی برای نمایش وجود ندارد.
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>

              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>

              <template v-slot:cell(operation)="row">
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <v-btn
                    :to="'/shop/customer/' + row.item.id"
                    class="orange-mainBtn mx-2 rounded-xl"
                    width="155"
                    height="40"
                    style="text-decoration: none"
                    ><v-icon class="me-1">mdi-eye</v-icon>مشاهده پروفایل</v-btn
                  >
                </div>
              </template>
              <template #row-details="row">
                <div
                  class="animated fadeIn mb-2"
                  style="text-align: center; vertical-align: middle"
                >
                  <v-btn
                    :to="'/shop/customer/' + row.item.id"
                    class="orange-mainBtn mx-2"
                    width="155"
                    height="40"
                    style="text-decoration: none"
                    ><v-icon class="me-1">mdi-eye</v-icon>مشاهده پروفایل</v-btn
                  >
                  <v-btn
                    class="green-mainBtn mx-2"
                    width="155"
                    height="40"
                    @click="openEditDialog(row.item)"
                    ><v-icon class="me-1">mdi-pencil-box-outline</v-icon
                    >ویرایش</v-btn
                  >
                </div>
              </template>
            </b-table>
            <v-row class="mt-6">
              <v-col>
                <div class="d-flex flex-row">
                  <span class="c-grey pt-2">نمایش در هر صفحه</span>
                  <div class="ms-3 me-3 number-box">
                    <v-select
                      outlined
                      v-model="perPage"
                      :items="perPageOptions"
                      @change="currentPage = 1"
                    ></v-select>
                  </div>
                </div>
              </v-col>
              <v-col class="d-flex flex-row">
                <span class="c-grey pt-2"> برو به صفحه </span>
                <div class="ms-3 me-3 number-box">
                  <v-select
                    outlined
                    v-model="whichPage"
                    type="number"
                    @change="goToPage()"
                    @click="goToPage()"
                    :items="computedIndex"
                  ></v-select>
                </div>
              </v-col>
              <v-col class="text-sm-center">
                <div>
                  <v-pagination
                    v-model="currentPage"
                    :length="Math.ceil(computedItems.length / perPage)"
                    :total-visible="5"
                    prev-icon="$ArrowLeft"
                    next-icon="$ArrowRight"
                    class="float-sm-end"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-card>
    <v-dialog v-model="newCustomerDialog" width="800">
      <v-card class="product-dialog-card">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">ثبت مشتری جدید</h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2">
              <span class="pointer" @click="newCustomerDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> نام و نام خانوادگی:</label
              >
              <v-text-field
                placeholder="نام و نام خانوادگی"
                outlined
                dense
                v-model="newCustomer.name"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> نوع مشتری:</label
              >
              <v-select
                placeholder="نوع مشتری"
                outlined
                dense
                hide-details
                type="number"
                :items="customerTypes"
                v-model="newCustomer.type"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"> کد ملی:</label>
              <v-text-field
                placeholder="کد ملی"
                outlined
                dense
                hide-details
                type="number"
                v-model="newCustomer.natCode"
              ></v-text-field>
              <span
                v-if="!checkCodeMeli(newCustomer.natCode)"
                class="red--text font-weight-bold"
                style="font-size: 0.8rem"
                >کد ملی وارد شده صحیح نمی‌باشد!</span
              >
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"> کد اقتصادی:</label>
              <v-text-field
                placeholder="کد اقتصادی"
                outlined
                dense
                hide-details
                type="number"
                v-model="newCustomer.economicCode"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">
                شماره تلفن موبایل:</label
              >
              <v-text-field
                placeholder="شماره تلفن موبایل"
                outlined
                dense
                hide-details
                type="number"
                v-model="newCustomer.mobile"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">
                شماره تلفن ثابت:</label
              >
              <v-text-field
                placeholder="شماره تلفن ثابت"
                outlined
                dense
                hide-details
                type="number"
                v-model="newCustomer.phone"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <label class="primary--text font-weight-bold"> آدرس:</label>
              <v-text-field
                placeholder="آدرس"
                outlined
                dense
                hide-details
                v-model="newCustomer.address"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <div class="text-left py-3 px-4">
          <v-btn
            class="red-mainBtn white--text mx-2"
            @click="newCustomerDialog = false"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="addCustomer()"
            :disabled="
              busy ||
              computedAddBtn ||
              (newCustomer.natCode && !checkCodeMeli(newCustomer.natCode))
            "
            class="green-mainBtn white--text"
            width="90"
          >
            افزودن
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editCustomerDialog" width="800">
      <v-card class="product-dialog-card">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">ویرایش مشتری</h4>
            </v-col>
            <v-col cols="2" class="text-left pt-2">
              <span class="pointer" @click="editCustomerDialog = false"
                ><v-icon>$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> نام و نام خانوادگی:</label
              >
              <v-text-field
                placeholder="نام و نام خانوادگی"
                outlined
                dense
                :loading="loading2"
                v-model="editCustomer.name"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0" md="6" cols="12">
              <label class="primary--text font-weight-bold"
                ><span class="red--text">*</span> نوع مشتری:</label
              >
              <v-select
                placeholder="نوع مشتری"
                outlined
                dense
                hide-details
                type="number"
                :loading="loading2"
                :items="customerTypes"
                v-model="editCustomer.type"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"> کد ملی:</label>
              <v-text-field
                placeholder="کد ملی"
                outlined
                dense
                hide-details
                type="number"
                :loading="loading2"
                v-model="editCustomer.natCode"
              ></v-text-field>
              <span
                v-if="!checkCodeMeli(editCustomer.natCode)"
                class="red--text font-weight-bold"
                style="font-size: 0.8rem"
                >کد ملی وارد شده صحیح نمی‌باشد!</span
              >
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold"> کد اقتصادی:</label>
              <v-text-field
                placeholder="کد اقتصادی"
                outlined
                dense
                hide-details
                type="number"
                :loading="loading2"
                v-model="editCustomer.economicCode"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">
                شماره تلفن موبایل:</label
              >
              <v-text-field
                placeholder="شماره تلفن موبایل"
                outlined
                dense
                hide-details
                type="number"
                :loading="loading2"
                v-model="editCustomer.mobile"
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="pt-0">
              <label class="primary--text font-weight-bold">
                شماره تلفن ثابت:</label
              >
              <v-text-field
                placeholder="شماره تلفن ثابت"
                outlined
                dense
                hide-details
                type="number"
                :loading="loading2"
                v-model="editCustomer.phone"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <label class="primary--text font-weight-bold"> آدرس:</label>
              <v-text-field
                placeholder="آدرس"
                outlined
                dense
                hide-details
                :loading="loading2"
                v-model="editCustomer.address"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <div class="text-left py-3 px-4">
          <v-btn
            class="red-mainBtn white--text mx-2"
            @click="editCustomerDialog = false"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="doEditCustomer()"
            :disabled="busy || computedEditBtn"
            class="green-mainBtn white--text"
            width="90"
          >
            ویرایش
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import moment from "moment-jalaali";
import { AtomSpinner } from "epic-spinners";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
function checkCodeMeli(code) {
  //NOTE employee's checking validation of national code
  var L = code.length;

  if (L < 8 || parseInt(code, 10) == 0) return false;
  code = ("0000" + code).substr(L + 4 - 10);
  if (parseInt(code.substr(3, 6), 10) == 0) return false;
  var c = parseInt(code.substr(9, 1), 10);
  var s = 0;
  for (var i = 0; i < 9; i++) s += parseInt(code.substr(i, 1), 10) * (10 - i);
  s = s % 11;
  return (s < 2 && c == s) || (s >= 2 && c == 11 - s);
  return true;
}

export default {
  components: {
    AtomSpinner,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      tab: null,
      moment: moment,
      filter: "",
      guide: false,
      busy: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [4, 10, 20],
      customers: [],
      newCustomer: {},
      editCustomer: {},
      selectedCustomer: {},
      newCustomerDialog: false,
      editCustomerDialog: false,
      loading: false,
      loading2: false,
      excelFields: [
        { field: "name", label: "نام مشتری" },
        { field: "customerCode", label: "کد مشتری" },
        { field: "mobile", label: "موبایل" },
      ],
      customersFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام مشتری" },
        { key: "customerCode", label: "کد مشتری" },
        { key: "mobile", label: "موبایل" },
        { key: "operation", label: "عملیات" },
      ],
      customerTypes: [
        { value: "naturalPerson", text: "حقیقی" },
        { value: "legalPerson", text: "حقوقی" },
      ],
      whichPage: 1,
    };
  },
  methods: {
    checkNatCode(id) {
      return id ? (checkCodeMeli(id) ? true : false) : false;
    },
    goToPage() {
      this.currentPage = Number(this.whichPage);
    },
    computedIcon(item) {
      if (item.royaltyTier == "coper") {
        return "/icons8-star-35(1).png";
      } else if (item.royaltyTier == "silver") {
        return "/icons8-star-35.png";
      } else if (item.royaltyTier == "gold") {
        return "/icons8-star-35(2).png";
      } else if (item.royaltyTier == "diamond") {
        return "/icons8-diamond-35.png";
      }
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    openNewProduct() {
      this.newCustomerDialog = true;
      this.guide = false;
    },
    openEditDialog(item) {
      this.selectedCustomer = item.id;
      this.getCustomerInfo();
      this.editCustomerDialog = true;
    },
    getCustomerInfo() {
      this.loading2 = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/customer/getInfo",
        {
          shopCustomerId: this.selectedCustomer,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.editCustomer = res.data;
            this.loading2 = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    showCustomers() {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            this.customers = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
        });
    },
    addCustomer() {
      this.busy = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/customer/new",
        {
          name: this.newCustomer.name,
          mobile: this.newCustomer.mobile,
          email: this.newCustomer.email,
          economicCode: this.newCustomer.economicCode,
          phone: this.newCustomer.phone,
          address: this.newCustomer.address,
          natCode: this.newCustomer.natCode,
          type: this.newCustomer.type,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.newCustomer = {};
            this.newCustomerDialog = false;
            this.showCustomers();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
    doEditCustomer() {
      this.busy = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/customer/edit",
        {
          shopCustomerId: this.selectedCustomer,
          name: this.editCustomer.name,
          mobile: this.editCustomer.mobile,
          email: this.editCustomer.email,
          economicCode: this.editCustomer.economicCode,
          phone: this.editCustomer.phone,
          address: this.editCustomer.address,
          natCode: this.editCustomer.natCode,
          type: this.editCustomer.type,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.editCustomerDialog = false;
            this.showCustomers();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.customerDialog = false;
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast(err.response.data, "error");
        });
    },
  },
  computed: {
    computedItems() {
      let filtered;
      filtered = this.customers.filter((x) => x.name.includes(this.filter));
      return filtered;
    },
    computedIndex() {
      let arr = [];
      let computedLength = this.computedItems.length;
      let arrlength = Math.ceil(computedLength / this.perPage);
      for (let i = 1; i <= arrlength; i++) {
        arr.push(i);
      }
      return arr;
    },
    computedAddBtn() {
      if (!this.newCustomer.name || !this.newCustomer.type) {
        return true;
      } else false;
    },
    computedEditBtn() {
      if (!this.editCustomer.name || !this.editCustomer.type) {
        return true;
      } else false;
    },
  },
  mounted() {
    this.showCustomers();
  },
};
</script>

<style lang="scss">
.customers {
  .sort-box {
    border-radius: 10px;
    padding: 7px 15px;
    color: #656a81;

    &.selected-sort {
      background-color: #00b4d8;
      color: #fff;
      &:hover {
        background-color: #00b4d8;
      }
    }
    &:hover {
      background-color: #eee;
    }
  }
  .orange-borderedBtn {
    background-color: #f4f4ff !important;
  }
}

.product-dialog-card {
  border-radius: 15px !important;
  padding: 10px;
  max-height: 680px;
  overflow-y: auto;
  .custom-input {
    .v-textarea {
      .v-input__slot {
        height: 246px !important;
      }
    }
    .v-input__slot {
      width: 100% !important;
    }
    .v-input__icon--append {
      padding-top: 3px !important;
      i {
        color: #7c4dff !important;
        cursor: pointer;
      }
    }
  }
}
</style>
